import React, {useEffect, useState} from 'react';
import { Table } from 'antd';
import {Redirect} from "react-router-dom";


const StatTable = ({imba_id, dataSource, columns}) => {
    const[loading, setLoading] = useState(true);
    const [choose, setChoose] = useState(false);

    useEffect(() => {
        //setLoading(false)
        //console.log(dataSource)
        if (dataSource)
            setLoading(false);
    }, [dataSource])
    return choose ? (
        <Redirect to = {{ pathname: `/${imba_id}/message/${choose}` }} />
    ) : (
        <Table columns={columns} pagination={false} dataSource={dataSource} loading={loading}
               />
    )
}
export default StatTable;